export default __webpack_public_path__ + "assets/cr_xmp_highlight.909c64ad.svg";